<template>
    <div
        class="engineer-overtime__row" 
        @click="$router.push({name: 'engineer.overtime.edit', params: {id: log.id}})"
    >
        <h4>{{ log.location }}</h4>
        <p v-if="log.vehicle_reg">
            <i class="fa fa-car" /> {{ log.vehicle_reg }}
        </p>
        <p>
            <i class="fa fa-clock" /> {{ time }}
        </p>
        <p>
            <i class="fas fa-hourglass-half" /> {{ log.duration_mins | minsToHours }} Total
        </p>
        <p>
            <i class="fas fa-hourglass-half" /> {{ log.overtime_mins | minsToHours }} Overtime
        </p>
        <p>
            <span v-if="log.verified_by"><i class="fa fa-check" /> Verified by {{ log.verified_by.name }} </span>
        </p>
        <p>
            <router-link
                :to="{name: 'engineer.overtime.edit', params: {id: log.id}}"
                class="btn btn-info"
            >
                View
            </router-link>
        </p>
    </div>
</template>
<script>
export default {
    props: {
        log: {
            required: true,
            type: Object,
        },
    },

    computed: {
        startTime () {
            return window.moment(this.log.start_time);
        },
        endTime () {
            return window.moment(this.log.end_time);
        },
        time () {
            return this.startTime.format('ddd Do MMM YYYY HH:mm') + ' - ' + this.endTime.format('HH:mm a')
        },
        paidAt () {
            if (!this.log.paid_at) {
                return null;
            }

            return window.moment(this.log.paid_at).format('DD/MM/YYYY HH:mm');
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/OvertimeRow.vue